import { makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Header from "./shared-components/Header";
import Footer from "./shared-components/Footer";
import Routes from "./shared-resources/routes";
import "./styles/carousel-custom.css";
import { getGeneralSettings, logout } from "./actions/admin-actions";
import AppLogout from "./AppLogout";
import "./App.css";

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    padding: "64px 0 0 0",
  },
}));

export default function App() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const logoutData = useSelector((state) => state.adminReducer.logoutData);

  useEffect(() => {
    if (
      localStorage.getItem("Is_Loggedin") &&
      localStorage.getItem("token") &&
      localStorage.getItem("Last_Login_Time")
    ) {
      if (
        location.pathname === "/settings/financial-management" &&
        JSON.parse(localStorage.getItem("isSuperUser"))
      )
        history.push("/settings/financial-management");
      else if (location.pathname === "/projects/ai-chat") {
      } else if (location.pathname.startsWith("/projects/reports")) {
      } else history.push("/projects/financial-dashboard");
      // if (
      //   (location.pathname === "/" || location.pathname === "/projects") &&
      //   localStorage.getItem("roles") &&
      //   (JSON.parse(localStorage.getItem("roles")).includes("MANAGER") ||
      //     JSON.parse(localStorage.getItem("roles")).includes("RM"))
      // )
      //   history.push("/projects/financial-dashboard");
      // if (location.pathname === "/settings") history.push("/");
      // if (location.pathname === "/projects") history.push("/");
      // if (
      //   location.pathname === "/" &&
      //   localStorage.getItem("roles") &&
      //   JSON.parse(localStorage.getItem("roles")).includes("ADMIN")
      // )
      //   history.push("/settings/financial-management");
      // if (
      //   (location.pathname === "/projects/project-management" &&
      //     localStorage.getItem("roles") &&
      //     !(
      //       JSON.parse(localStorage.getItem("roles")).includes("MANAGER") ||
      //       JSON.parse(localStorage.getItem("roles")).includes("RM")
      //     )) ||
      //   (location.pathname === "/projects/resource-management" &&
      //     localStorage.getItem("roles") &&
      //     !(
      //       JSON.parse(localStorage.getItem("roles")).includes("MANAGER") ||
      //       JSON.parse(localStorage.getItem("roles")).includes("RM")
      //     )) ||
      //   (location.pathname === "/projects/reports" &&
      //     localStorage.getItem("roles") &&
      //     !(
      //       JSON.parse(localStorage.getItem("roles")).includes("MANAGER") ||
      //       JSON.parse(localStorage.getItem("roles")).includes("RM")
      //     )) ||
      //   ((location.pathname === "/settings/general-settings" ||
      //     location.pathname === "/settings/project-management" ||
      //     location.pathname === "/settings/resource-management") &&
      //     localStorage.getItem("roles") &&
      //     !JSON.parse(localStorage.getItem("roles")).includes("ADMIN"))
      // )
      //   history.push("/");
    } else if (location.pathname === "/create-user") {
    } else if (
      location.pathname.includes("sso") &&
      !location.pathname.includes("sso/result")
    ) {
      window.location = `${process.env.SSO_REDIRECT_URL}/user-setting/sso`;
    } else if (
      location.pathname.includes("sso/result") ||
      location.pathname.includes("logout")
    ) {
    } else if (location.pathname.includes("login")) {
    } else if (
      location.pathname === "/emailverify" ||
      location.pathname === "/otpvalidate" ||
      location.pathname === "/changepassword"
    ) {
    } else if (location.pathname === "/") {
      history.push("/login");
    } else {
      history.push("/sso");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      location.pathname !== "/projects/project-details" &&
      localStorage.getItem("newlyAddedResource")
    )
      localStorage.removeItem("newlyAddedResource");
  }, [location.pathname]);

  useEffect(() => {
    if (
      localStorage.getItem("Last_Login_Time") &&
      new Date() - new Date(localStorage.getItem("Last_Login_Time")) >
        12 * 60 * 60 * 1000
    ) {
      dispatch(logout());
    } else if (localStorage.getItem("Last_Login_Time"))
      dispatch(getGeneralSettings());
  }, []);

  useEffect(() => {
    if (
      logoutData &&
      logoutData.status &&
      (logoutData.status === 200 || logoutData.status === 400)
    ) {
      localStorage.clear();
      setTimeout(() => (window.location.href = "/logout"), 100);
    }
  }, [logoutData]);

  return (
    <div
      className={
        location.pathname === "/login" ||
        location.pathname === "/emailverify" ||
        location.pathname === "/otpvalidate" ||
        location.pathname === "/changepassword" ||
        location.pathname === "/create-user" ||
        location.pathname === "/logout" ||
        location.pathname === "/projects/ai-chat"
          ? classes.loginWrapper
          : classes.contentWrapper
      }
    >
      {location.pathname === "/login" ||
      location.pathname === "/emailverify" ||
      location.pathname === "/otpvalidate" ||
      location.pathname === "/changepassword" ||
      location.pathname === "/logout" ||
      location.pathname === "/create-user" ||
      location.pathname.includes("/sso") ? (
        <Routes />
      ) : location.pathname === "/projects/ai-chat" ? (
        <AppLogout>
          <Routes />
        </AppLogout>
      ) : (
        <AppLogout>
          <Header />
          <Routes />
        </AppLogout>
      )}
    </div>
  );
}
